import useAsyncRequest from "../../CustomHooks/useAsyncRequest"
import ContributorBar from "../../Github/Contributos/ContributorBar"
import useGetContributors from "../../Github/Hooks/useGetContributors"
import { supabase } from "../../router"
import Background from "../Backgrounds/Background"
import { Carousel, HiddenContent, ImgSlide } from "../Carousel"
import { Page } from "../Page"
import { LanguageBar, ProjectSourceCode, ProjectText, ProjectTitle } from "../ProjectPage"
import { ProjectSourceCodeV2 } from "../SourceCode/ProjectSourceCodeV2"

export function ImageSegmentation(){

    let response = useAsyncRequest( async setResponse => {
        let { data, error } = await supabase
        .rpc('get_project_data', {
            project_name: "Image Segmentation"
        })

        if (error) console.error(error)
        else console.log(data)

        setResponse({
            data: data,
            error: error
        });
    });
    
    const repo = response?.data[0]?.repo;
    const owner = response?.data[0]?.ownername;
    const contributors = useGetContributors({ repo: repo , owner: owner})

    let body = null;
    if (response !== null) {
        let projectData = response.data[0];
        let results = projectData.imgs.map((imgData, index ) => {
            let isResultImg = index < 10 && imgData.name !== "keys2";
            if (isResultImg) {
                return <ImgSlide key = {index} imgData={imgData} status={"pass"} />
            }
        }).filter(slide => {
            return slide !== undefined;
        });

        let fixedKeys = projectData.imgs.filter(imgData => {
            return imgData.name === "keys2";
        })[0];
        let fixedSlide = <ImgSlide key={1} imgData={fixedKeys} status={"pass"} />;
        let sourceFiles = projectData.files;
        const oneHr = 3600 * 1000;
        console.log(response);

        body = <Page>
            <ProjectTitle title={projectData.name} />
            <LanguageBar languages={projectData.langs}/>
            <ContributorBar contributors={contributors}/>
            <ProjectText text={projectData.abstract[0]} title={"Overview:"}/>
            <Carousel items={results} title={"Results"} elevation={4} interval={3000} />
            <ProjectText text={projectData.paragraphs[0].paragraph} title={"Observations:"}/>
            <Carousel items={[fixedSlide]} title={"Results"} elevation={4} interval={oneHr} />
            
            <HiddenContent
                messages={[
                    "View source",
                    "Display source code",
                    "See implementation"
                ]}

                btnText={"Show"}
                interval={3000}
                elevation={4}
            >
                <ProjectSourceCodeV2 elevation={4} directory={projectData?.directory}/>
            </HiddenContent>
        </Page>
    }
    return (<>
        {body}
    </>)
}